<template>
    <div class="wapper">
        <el-container style="100%">
            <el-main style="background:#fff;">
                <div class="table-wrap">
                    <div class="handle-box3">
                        <el-form :inline="true" ref="form" :model="searchForm" class="demo-form-inline">
                            <div class="uers-left">
                                <el-form-item label="查询结果：">
                                    <el-tag><b>{{ label }}</b></el-tag>
                                </el-form-item>
                                <br>
                                <el-form-item label="搜索：">
                                    <el-input v-model="searchForm.name" placeholder="名称"></el-input>
                                </el-form-item>
                                <el-form-item label="">
                                    <el-input v-model="searchForm.phone" placeholder="手机"></el-input>
                                </el-form-item>
                                <el-form-item label="">
                                    <el-input v-model="searchForm.idCard" placeholder="身份证"></el-input>
                                </el-form-item>
                                <el-form-item label="">
                                    <el-input v-model="searchForm.wechatPayGuid" placeholder="支付流水"></el-input>
                                </el-form-item>
                                <el-form-item label="">
                                    <el-date-picker v-model="searchForm.startDate" type="datetime"
                                                    placeholder="开始日期"></el-date-picker>
                                </el-form-item>
                                <el-form-item label="">
                                    <el-date-picker v-model="searchForm.endDate" type="datetime"
                                                    placeholder="开始日期"></el-date-picker>
                                </el-form-item>
                                <el-button type="primary" icon="el-icon-search" @click="getData">搜索</el-button>
                            </div>
                        </el-form>
                    </div>
                    <div class="uers-right">
                <span class="btn-r">
                <el-button
                        type="primary"
                        icon="el-icon-export"
                        @click="exportExcel()"
                >导出
                </el-button
                >
                  <el-button
                          type="danger"
                          @click="deleteNotPay()"
                          plain class="red">删除未支付
                  </el-button>
                </span>
                    </div>
                    <div class="tabbox">
                        <el-table
                                :data="dataList"
                                height="100%"
                                border
                                class="table"
                                ref="multipleTable"
                                :header-cell-style="{background:'#f2f6fc',color:'#606266'}"
                                @selection-change="handleSelectionChange"
                        >
                            <el-table-column prop="orderFormId" label="ID" width="80" align="center"></el-table-column>
                            <el-table-column prop="typeName" width="180" label="票证类型" align="center">
                                <template slot-scope="scope">
                                    <span>{{ "类型名称：" + scope.row.typeName }}</span><br/>
                                    <span>{{ scope.row.ticketTypeId ? "票类型ID：" + scope.row.ticketTypeId : "" }}</span>
                                    <span>{{ scope.row.documentTypeId ? "证件类型ID：" + scope.row.documentTypeId : "" }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="name" label="姓名" min-width="100" align="center">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.name }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="phone" label="手机" min-width="100" align="center">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.phone }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="idCard" min-width="200" label="身份证/流水号" align="center">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.idCard }}</span><br/>
                                    <span>{{scope.row.wechatPayGuid}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="amount" label="金额" max-width="60" align="center">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.amount }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="count" label="数量" max-width="60" align="center">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.count }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="isPay" label="是否支付" max-width="80" align="center">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.isPay == 0 ? "未支付" : "已支付" }}</span><br/>
                                    <el-button
                                            v-if="scope.row.isPay===0"
                                            type="text"
                                            class="red"
                                            @click="handleDelete(scope.$index, scope.row)"
                                    >删除
                                    </el-button>
                                </template>
                            </el-table-column>
                            <el-table-column prop="createDate" width="180" label="创建日期" align="center">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.createDate }}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="fb">
                        <el-pagination
                                class="pag"
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage"
                                :page-sizes="[5, 10, 15, 20, 50, 100]"
                                :page-size="pagesize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total"
                                background
                        ></el-pagination>
                    </div>
                </div>
                <DeleteDialog
                        :delVisible="delVisible"
                        @deleteData="deleteData"
                        @handleCloseVisible="handleCloseVisible"
                ></DeleteDialog>
            </el-main>
        </el-container>
    </div>
</template>
<script>

    import DeleteDialog from "../../../components/public/DeleteConfim";

    export default {
        data() {
            return {
                projectId: localStorage.getItem("project_Id"),
                total: 0, //总条数
                currentPage: 1, //初始页
                pageSize: 15, // 每页的数据
                //表格高度适配
                tabHeight: "",
                label: "",
                delVisible: false,
                searchForm: {
                    wechatPayGuid: "",
                    idCard: "",
                    name: "",
                    phone: "",
                    endDate: new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1),
                    startDate: new Date(new Date(new Date().toLocaleDateString()).getTime() - 7 * 24 * 60 * 60 * 1000)
                },
                ticketCom_Id: "",
                dataList: [],
                multipleSelection: []
            };
        },
        mounted() {
            // this.tabheight=(this.$refs.getheight.offsetHeight-165)
        },
        created() {
            this.getData();
        },
        methods: {
            handleSizeChange(val) {
                this.pagesize = val;
                this.searchSubmit();
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.searchSubmit();
            },
            exportExcel() {
                var search = {
                    name: this.searchForm.name,
                    idCard: this.searchForm.idCard,
                    wechatPayGuid: this.searchForm.wechatPayGuid,
                    pageIndex: this.currentPage - 1,
                    pageSize: this.pagesize,
                    phone: this.searchForm.phone,
                    startDate: this.searchForm.startDate,
                    endDate: this.searchForm.endDate,
                    projectId: this.projectId,
                }
                const loading = this.$loading({
                    lock: true,
                    text: "Loading",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)",
                });
                this.$axios
                    .post(`/OrderForm/Export`, search)
                    .then((res) => {
                        loading.close();
                        if (res.data.data) {
                             window.open(res.data.data, '_self');
                            // this.$download(res.data.data, '导出证件.xlsx');
                        } else {
                            this.$message.error("导出失败");
                        }
                    })
                    .catch((a) => {
                        loading.close();
                        this.$message.error("导出失败");
                    });
            },
            searchSubmit() {
                var search = {
                    name: this.searchForm.name,
                    idCard: this.searchForm.idCard,
                    wechatPayGuid: this.searchForm.wechatPayGuid,
                    pageIndex: this.currentPage - 1,
                    pageSize: this.pagesize,
                    phone: this.searchForm.phone,
                    startDate: this.searchForm.startDate,
                    endDate: this.searchForm.endDate,
                    projectId: this.projectId,
                }
                this.$axios.post('/OrderForm/Search', search)
                    .then(res => {
                        if (res.data.hasError == false) {
                            this.dataList = [...res.data.data]
                            this.total = res.data.total;
                        }
                    })

                this.$axios.post('/OrderForm/SearchAll', search)
                    .then(res => {
                        if (res.data.hasError == false) {
                            this.label = "已支付购票数量：" + res.data.data[0] + ", 未支付购票票数：" + res.data.data[1] + " ,已支付购票金额：" + res.data.data[2] + " ,未支付购票金额：" + res.data.data[3] + " ,云尚系统购票数量：" + res.data.data[4] + " ,云尚系统购票金额：" + res.data.data[5];
                        }
                    })
            },
            // 获取数据
            getData() {
                this.currentPage = 1;
                this.searchSubmit();
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            deleteNotPay() {
                this.$confirm("是否删除5分钟前未支付的订单吗？", "提示", {
                    confirmButtonText: "确认",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(() => {
                    this.$axios.delete(`/OrderForm/NotPay/${this.projectId}`).then((res) => {
                        if (res.data.hasError) {
                            this.$message.error(res.data.message);
                        } else {
                            this.$message.success("删除成功！");
                            this.delVisible = false;
                            this.getData();
                        }
                    }).catch(() => {
                    });
                });
            },
            handleDelete(index, row) {
                this.ticketCom_Id = row.orderFormId;
                this.delVisible = true;
            },
            handleCloseVisible() {
                this.ticketCom_Id = "";
                this.delVisible = false;
            },
            deleteData() {
                this.$axios.delete(`/OrderForm/${this.ticketCom_Id}`).then((res) => {
                    if (res.data.hasError) {
                        this.$message.error(res.data.message);
                    } else {
                        this.$message.success("删除成功！");
                        this.delVisible = false;
                        this.getData();
                    }
                });
            },
        },
        components: {
            DeleteDialog
        }
    };
</script>
<style lang="scss" scope>
    .pag {
        position: absolute;
        bottom: 0;
    }

    .table-wrap {
        height: 100%;
        margin-left: 10px;
    }

    .el-main {
        border-radius: 5px;
        position: relative;
    }

    .uers-left {
        float: left;
    }

    .uers-right {
        float: right;
        margin: 10px 10px 10px 10px;
    }

    .tabbox {
        height: calc(100% - 150px);
    }
</style>